import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCalendarIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "14px",
	height: "14px",
	viewBox: "0 0 13.859 15.245",
	fill: "#323338",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "Path_7463",
		"data-name": "Path 7463",
		d: "M14.473,2.386H13.78V1.693a.693.693,0,0,0-1.386,0v.693H5.465V1.693a.693.693,0,1,0-1.386,0v.693H3.386A1.39,1.39,0,0,0,2,3.772V14.859a1.39,1.39,0,0,0,1.386,1.386H14.473a1.39,1.39,0,0,0,1.386-1.386V3.772A1.39,1.39,0,0,0,14.473,2.386ZM13.78,14.859h-9.7a.7.7,0,0,1-.693-.693V5.851H14.473v8.316A.7.7,0,0,1,13.78,14.859Z",
		transform: "translate(-2 -1)"
	})
});
export { SvgCalendarIcon as ReactComponent };
